import { ENDPOINTS } from '@api/endpoints';
import api, { handleError } from '@/api';

const {
  USER: { GET_ALL_USERS, GET_CURRENT_USER_DETAILS, SEARCH_USER_BY_EMAIL, INVITE_USER },
} = ENDPOINTS;

export default {
  /**
   * Get all users
   * @returns All users
   * @throws {{ code: string; message: string }} - If the get all users api fails
   */
  getAllUsers: async (signal?: AbortSignal) => {
    try {
      const response = await api.get<typeof GET_ALL_USERS.responseType>(GET_ALL_USERS.path, { signal });
      return {
        status: true,
        data: response.data,
      };
    } catch (error) {
      throw handleError(error);
    }
  },
  getCurrentUserDetails: async (signal?: AbortSignal) => {
    try {
      const response = await api.get<typeof GET_CURRENT_USER_DETAILS.responseType>(GET_CURRENT_USER_DETAILS.path, { signal });
      return {
        status: true,
        data: response.data,
      };
    } catch (error) {
      throw handleError(error);
    }
  },
  /**
   * Search user(s) by email
   */
  searchUserByEmail: async (email: string) => {
    try {
      const response = await api.get<typeof SEARCH_USER_BY_EMAIL.responseType>(
        SEARCH_USER_BY_EMAIL.path(email)
      );
      return {
        status: true,
        data: response.data,
      };
    } catch (error) {
      throw handleError(error);
    }
  },
  /**
   * Invite a user by email (optionally include groupId)
   */
  inviteUser: async ({ email, groupId }: { email: string; groupId?: number }) => {
    try {
      const response = await api.post<typeof INVITE_USER.responseType>(
        INVITE_USER.path,
        { email, ...(groupId ? { groupId } : {}) }
      );
      return {
        status: true,
        data: response.data,
      };
    } catch (error) {
      throw handleError(error);
    }
  },
};
